// ── Переключатель языка ──────────────────────────────────────────────────────
//
// Интерфейс всегда русский, переключать нечего — кнопка ничего не рисует.
// Компонент оставлен, чтобы не править десяток страниц, которые его вставляют:
// он просто исчезает из шапок.
export default function LangSwitch() {
  return null;
}
